import { MDBBtn, MDBChip, MDBIcon, MDBModalFooter, MDBSpinner } from 'mdb-react-ui-kit'
import React, { useEffect, useState } from 'react'
import { useForm } from 'react-hook-form'
import { useNavigate } from 'react-router';
import { createFaxGroup, createSMSGroup, getMisc } from '../../../apiclients/streamsapi_bridge';
import { formattedNumber, unFormatNumber } from '../phonenumbers/AddRemoveNumbers';
import { useTranslation } from 'react-i18next';
import AddNumbersStatic from '../phonenumbers/AddNumbersStatic';
import PopupLoader from '../PopupLoader';
function AddFaxGroup(props) {
    const { t, i18n } = useTranslation();
    const navigate = useNavigate();
    const [isloading, setIsloading] = useState(false);
    const [faxPhoneNums, setFaxPhoneNums] = useState([]);
    const [sourceNumber, setSourceNumber] = useState([]);
    const [removePHNum, setRemovePHNum] = useState([]);
    const [addPHNum, setAddPHNum] = useState([]);
    const [updateNumbersExecuted, setUpdateNumbersExecuted] = useState(true);
    const { register, watch, handleSubmit, formState: { isDirty, errors }, setError, clearErrors, reset, setValue } = useForm({
        name: "",
        // retries: 1,
        adddids:[],
    }
    );
    const [addNumbers, setAddNumbers] = useState(false);
    const toggleNumbers = () => setAddNumbers(!addNumbers);

    const onsubmit = async (data) => {
        // let updates = {};
        // if (isDirty) {
            let updates = {
                reqid: 116,
                siteid: JSON.parse(sessionStorage.getItem("admin_session")).siteid,
                name: data.name,
                adddids: data.adddids ?? [],

            };
        // }
        //alert(JSON.stringify(updates))
        console.log("JSON Create fax Group:: " + JSON.stringify(updates));
        setIsloading(true);
        let saverep = await createFaxGroup(updates);
        console.log(`reponse of add fax Group :::: ${JSON.stringify(saverep)}`);
        let saverepeMsg = await saverep.json();
        console.log(`reponse of add fax Group after:::: ${JSON.stringify(saverepeMsg)}`);
        setTimeout(() => {
            setIsloading(false);
        }, 2000);
        if (saverepeMsg.status && saverepeMsg.status == "success") {
            localStorage.setItem("s_message", saverepeMsg.message);
            props.onClose();

            window.location.href = "/faxgroupslandingpage";

        } else {
            if (saverepeMsg.message?.errors) {
                saverepeMsg.message.errors.forEach((err) => {
                    setError(err.param_name, {
                        type: "server",
                        message: err.message,
                    });
                    const fieldElement = document.querySelector(
                        `input[name="${err.param_name}"]`
                    );
                    if (fieldElement) {
                        fieldElement.focus();

                    }
                });
            }

        }
    }

    const handleDelete = (num) => {
        clearErrors("adddids");
        const number = unFormatNumber(num);
        const updateAddPHNum = addPHNum.filter((addNum) => addNum !== number);
        setFaxPhoneNums(updateAddPHNum);
        setValue("adddids", updateAddPHNum, {shouldDirty : true});
        
    };
    useEffect(() => {
        getFreePhoneNumbers();
    }, []);

    async function getFreePhoneNumbers() {
        let updates = {};
        console.log(sessionStorage.getItem("admin_session"));
        updates = {
            misc: ["free_dids"],
        };

        const response = await getMisc(
            JSON.parse(sessionStorage.getItem("admin_session")).siteid,
            updates
        );
        if (!response.json) {
            const message = `An error has occured: ${response.statusText}`;
            return;
        }
        const basicInfo = await response.json();
        if (!basicInfo) {
            window.alert(`info with id  not found`);
            navigate("/");
        }
        console.log("response data is :::::::::: " + JSON.stringify(basicInfo));
        setSourceNumber(basicInfo?.misc?.free_dids ?? []);
    }

    useEffect(() => {
        if (
            (addPHNum.length > 0) &&
            !updateNumbersExecuted
        ) {
            updateAddedNumbers();
            setUpdateNumbersExecuted(true);
        }
    }, [addPHNum, updateNumbersExecuted]);

    function updateAddedNumbers() {
        clearErrors("adddids");
        setFaxPhoneNums(addPHNum);
        setValue("adddids", addPHNum, {shouldDirty : true});
    }

    return (
        <>
            <div className="tel-numbers ">
                <strong>Fax Group Name</strong>
            </div>
            <div className="form pt-1">
                <input
                    maxLength={20}
                    type="text"
                    {...register("name"
                    //     , {
                    //     required: "Name is required",
                    // }
                )}
                    className="w-100 form-control" />
                {errors.name && (
                    <p className="text-danger">{errors.name.message}</p>
                )}
            </div>
            {/* <div className="tel-numbers mt-2">
                <strong>Retries</strong>
            </div>
            <div className="form pt-1">
                <select
                    className="form-control form-select w-100"
                    {...register("retries", { setValueAs: (value) => Number(value) })}

                >
                    {Array.from({ length: 20 }, (_, i) => (
                        <option key={i + 1} value={i + 1}>
                            {i + 1}
                        </option>
                    ))}
                </select>
                {errors.retries && (
                    <p className="text-danger">{errors.retries.message}</p>
                )}
            </div> */}

            <div className="add-numbermain">
                <div className="tel-numbers">{t("telephone_Numbers")}</div>
                <MDBBtn
                    className="mb-2"
                    onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        toggleNumbers();
                    }}
                >
                    <MDBIcon fas icon="plus" size="sm" /> {t("add_Numbers")}
                </MDBBtn>
            </div>

            <div className="chips chips-placeholder">
                {faxPhoneNums &&
                    faxPhoneNums.length > 0 &&
                    faxPhoneNums.map((phone) => (
                        <>
                            <span>
                                <MDBChip
                                    className="m-chip d-inline py-2 px-3"
                                    label="Example label"
                                    onDelete={() => handleDelete(phone)}
                                    closeIcon={true}
                                    key={phone}
                                    size="sm"
                                >
                                    {formattedNumber(phone)}
                                </MDBChip>
                            </span >
                        </>
                    ))}
            </div >
            {errors?.adddids && (
                <p className="text-danger text-end">
                    {errors.adddids.message}
                </p>
            )}


            <MDBModalFooter>
                <MDBBtn color='secondary' onClick={(e) => props.onClose(e)}>
                    Cancel
                </MDBBtn>
                <MDBBtn onClick={(e) => {
                    e.preventDefault();
                    handleSubmit(onsubmit)();
                }}>Add</MDBBtn>
            </MDBModalFooter>
            {
                isloading && (
                    <>
                        <div className="loadingclass">
                            <MDBBtn disabled>
                                <MDBSpinner size="sm" role="status" tag="span" className="me-2" />
                                Loading...
                            </MDBBtn>
                        </div>
                    </>
                )
            }

            {
                addNumbers && (
                    <PopupLoader
                        // size="lg"
                        // className="modal-lg"
                        title={"Add Numbers"}
                        content={
                            <AddNumbersStatic
                                selectedNum={faxPhoneNums}
                                setaddPHNum={setAddPHNum}
                                removePHNum={removePHNum}
                                setRemovePHNum={setRemovePHNum}
                                setUpdateNumbersExecuted={setUpdateNumbersExecuted}
                                sourceNumber={sourceNumber}
                                onClose={toggleNumbers}
                            />
                        }
                        onShow={setAddNumbers}
                        onClose={toggleNumbers}
                    />
                )
            }
        </>
    )
}

export default AddFaxGroup
